// @ts-expect-error - untyped import
import SnowflakeColumnSortEditor from 'reporting-snowflake/relational/modify/sorts/SnowflakeColumnSortEditor';
import { VisualTypes } from 'reporting-snowflake/relational/schema/visual-records';
import { getDimensions } from 'reporting-snowflake/relational/utils/column-utils';
import { getReportVisualType } from 'reporting-snowflake/relational/utils/report-utils';
import { useRelationalReportData } from '../../../contexts/RelationalReportContext';
import useSRVSnowflakeUpdater from '../../../hooks/relationalReports/useSRVSnowflakeUpdater';
import { jsx as _jsx } from "react/jsx-runtime";
const RelationalReportSortSelectorDropdown = ({
  onChange,
  report
}) => {
  const {
    relationalReport
  } = useRelationalReportData();
  const {
    updateColumnSort
  } = useSRVSnowflakeUpdater(report);
  const visualType = getReportVisualType(relationalReport);
  const column = getDimensions(relationalReport.columns).first();
  const handleSortChange = columnSort => {
    if (!column) {
      return;
    }
    const updatedColumn = column.set('sort', columnSort);
    const result = updateColumnSort(column.alias, updatedColumn);
    if (result.updatedReport) {
      onChange(result.updatedReport);
    }
  };
  return visualType !== VisualTypes.TABLE ? /*#__PURE__*/_jsx(SnowflakeColumnSortEditor, {
    report: relationalReport,
    column: column,
    onChange: handleSortChange
  }) : null;
};
export default RelationalReportSortSelectorDropdown;